import { format, parseISO, isValid } from 'date-fns';

/**
 * Format date string
 */
export const formatDate = (dateStr, fmt = 'dd MMM yyyy') => {
  if (!dateStr) return '—';
  const date = typeof dateStr === 'string' ? parseISO(dateStr) : dateStr;
  return isValid(date) ? format(date, fmt) : '—';
};

/**
 * Format date with time
 */
export const formatDateTime = (dateStr) => {
  return formatDate(dateStr, 'dd MMM yyyy, hh:mm a');
};

/**
 * Format currency (INR)
 */
export const formatCurrency = (amount) => {
  if (amount == null || isNaN(amount)) return '—';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
};

/**
 * Format number with commas
 */
export const formatNumber = (num) => {
  if (num == null || isNaN(num)) return '—';
  return new Intl.NumberFormat('en-IN').format(num);
};

/**
 * Get initials from name
 */
export const getInitials = (name) => {
  if (!name) return '?';
  return name
    .split(' ')
    .map((w) => w[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
};

/**
 * Capitalize first letter and replace underscores
 */
export const humanize = (str) => {
  if (!str) return '';
  return str
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

/**
 * Truncate text
 */
export const truncate = (str, maxLen = 50) => {
  if (!str || str.length <= maxLen) return str;
  return str.slice(0, maxLen) + '…';
};

/**
 * File size formatter
 */
export const formatFileSize = (bytes) => {
  if (!bytes) return '0 B';
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${sizes[i]}`;
};
